export default {
    title1: "首頁",
    title2: "商品列表",
}